import { render, staticRenderFns } from "./visaCard.vue?vue&type=template&id=5de93a22&scoped=true&"
import script from "./visaCard.vue?vue&type=script&lang=js&"
export * from "./visaCard.vue?vue&type=script&lang=js&"
import style0 from "./visaCard.vue?vue&type=style&index=0&id=5de93a22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de93a22",
  null
  
)

export default component.exports